
import { defineComponent, PropType } from 'vue';
import { CatalogDetail, CatalogProductItem } from '@/common/services/swagger/index.defs';

import { TranslateFunc } from '@/catalogs/composables/setupComponent';
import PIS from '@/common/api/PIS';
import { Instance } from '@/catalogs/api/Instance';
import {
  CatalogProductCopyActionCommand,
  CatalogProductDeleteActionCommand,
  CatalogProductEditActionCommand,
} from '@/catalogs/api/runtime/CommandExecutor';

export default defineComponent({
  components: {},
  props: {
    t: { type: Function as PropType<TranslateFunc>, required: true },
    close: { type: Function, required: true },
    instanceId: String,
    product: { type: Object as PropType<CatalogProductItem>, required: true },
    catalog: { type: Object as PropType<CatalogDetail>, required: true },
    editable: { type: Boolean, default: false },
  },
  setup(props) {
    const instance = PIS.Catalogs.getInstance(props.instanceId) as Instance;
    const onCatalogProductEditAction = async () => {
      try {
        instance.execute(
          new CatalogProductEditActionCommand({ product: props.product, catalog: props.catalog }),
        );
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogProductCopyAction = async () => {
      try {
        instance.execute(
          new CatalogProductCopyActionCommand({ product: props.product, catalog: props.catalog }),
        );
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogProductDeleteAction = async () => {
      try {
        instance.execute(new CatalogProductDeleteActionCommand({ product: props.product }));
      } catch (error) {
        // Ignore error
      }
    };
    return {
      onCatalogProductEditAction,
      onCatalogProductCopyAction,
      onCatalogProductDeleteAction,
    };
  },
});
